<template>
  <div id="dashboard-page" class="application-page">
    <div class=" split-page z-depth-2">
      <div class="dashboard-header">
        <h5>{{ $t('dashboard.alerts') }}</h5>
        <a href="#/alarmlist" class="blue-color">{{ $t('dashboard.openalertlist') }}</a>
      </div>
      <dashboard-alarmlist/>
      <dashboard-oilsensorlist/>
    </div>
    <div class="split-page z-depth-2">
      <div class="dashboard-header">
        <h5>{{ $t('views.dashboard.selector.railobjects') }}</h5>
        <a href="#/search" class="blue-color">{{ $t('dashboard.openhierarchy') }}</a>
      </div>
      <div class="tab-content">
        <div @click="tab = 'hierarchy'" class="tab clickable" v-bind:class="{'active': tab === 'hierarchy'}">{{ $t('dashboard.hiearchy') }}</div>
        <div @click="tab = 'map'" class="tab clickable" v-bind:class="{'active': tab === 'map'}">{{ $t('dashboard.map') }}</div>
        <div class="tab-page" v-bind:class="{'tab-page-fixed': tab === 'map'}">
          <dashboard-map :railObjects="railObjects" :lastUpdated="lastUpdated" v-show="tab === 'map'"/>
          <dashboard-hierarchy v-show="tab === 'hierarchy'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RailObjectService from '../../services/RailObjectService'
import Hierarchy from './_Hierarchy'
import AlarmList from './_AlarmList'
import OilSensorList from './_OilSensorList'
import DashboardMap from './DashboardMap'

export default {
  name: 'dashboard',
  components: {
    'dashboard-hierarchy': Hierarchy,
    'dashboard-alarmlist': AlarmList,
    'dashboard-oilsensorlist': OilSensorList,
    'dashboard-map': DashboardMap
  },
  data () {
    return {
      tab: 'map',
      lastUpdated: new Date(),
      railObjects: []
    }
  },
  beforeCreate: function () {
  },
  created: function () {
    this.railObjects = RailObjectService.getRailObjects()
    this.lastUpdated = new Date()
  },
  mounted: function () {
    // var me = this
    // MaintenanceNotificationSingle.startMaintenanceNotificationMonitoring(function (message) {
    //   me.$notify({
    //     group: 'maintenance',
    //     type: 'warn',
    //     title: 'x',
    //     text: me.$t(message),
    //     duration: 999999999,
    //     speed: 1000
    //   })
    // })
  },
  beforeDestroy: function () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tab-content {
  width: 100%;
}

.tab-content .tab,
.tab-content .info {
  width: 50%;
  position: relative;
  float: left;
  display: block;
  text-align: center;
  padding: 10px 0px;
  color: #56CCF2;
}

.tab-page-fixed {
  height: calc(100vh - 190px);
}

.tab-page {

  position: relative;
  float: left;
  width: 100%;
}

.tab.active::after {
  content: '';
  top: 0px;
  left: 0px;
  position: absolute;
  width:100%;
  height:100%;
  border-bottom: 3px solid #56CCF2;
}

#dashboard-page {
  width: 100%;
  position: relative;
  height: calc(100vh - 56px);
  overflow-y: auto;
}

.split-page {
  margin: 10px;
  width: calc(50% - 20px);
  position: relative;
  float: left;
  /* height: calc(100vh - 110px); */
  /* overflow-y: auto; */
  background-color: #fff;
}

.dashboard-header {
  margin: 0px 10px;
  height: 60px;
  line-height: 60px;
}

.dashboard-header > h5 {
  position: relative;
  float: left;
}

.dashboard-header > a {
  position: relative;
  float: right;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/Dashboard.vue